export default __webpack_public_path__ + "static/signup-thumb-break-f50294d6dae412a31dc6cc266673cae7.jpg";